export default __webpack_public_path__ + "static/media/17.ba3fe849.png";